import React, {ChangeEvent, useState} from 'react';
import { Link } from 'react-router-dom';

interface Step1Props {
  persons: string[];
  setPersons: React.Dispatch<React.SetStateAction<string[]>>;
}

function Step1(props: Step1Props) {
  const [personsObj, setPersonsObj] = useState<{[key: string]: string}>({});
  const { setPersons } = props;

  const [labelFocus, setLabelFocus] = useState<{[key: string]: string}>({
    '1': '',
    '2': '',
    '3': '',
    '4': '',
    '5': '',
    '6': '',
    '7': '',
    '8': '',
  });

  const personChange = (e: ChangeEvent<HTMLInputElement>) => {
    personsObj[e.currentTarget.id] = e.currentTarget.value;
    setPersonsObj(personsObj);
    const unique = Object.values(personsObj)
      .filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
    setPersons(unique);
  }

  const blurCheck = (e: React.FocusEvent<HTMLInputElement>, id: string) => {
    if (e.currentTarget.value.length === 0) {
      labelFocus[id] = '';
      setLabelFocus({...labelFocus});
    }
  };

  // todo: labels animation
  return (
    <div className="step step1">
      <h2>Schritt 1: Wer arbeitet mit/an dem Algorithmensystem?</h2>

      <p>
        Geben Sie hier bitte alle Personen oder Gruppen ein, die in die Entscheidung über den <strong>Einsatz
        des Systems</strong>,
        dessen <strong>Implementierung</strong>, <strong>Entwicklung</strong>, <strong>Anwendung</strong> oder <strong>Evaluierung</strong> und
        die damit zusammenhängende <strong>Datenverwaltung</strong> involviert sind.
      </p>

      <form>
        <div className={'form-group' + labelFocus['1']}>
          <label htmlFor="person1" className="control-label">Person 1</label>
          <input id="person1" type="text" className="form-control"
                 onChange={(e) => personChange(e)}
                 onFocus={() => {labelFocus['1'] = ' focused'; setLabelFocus({...labelFocus})}}
                 onBlur={(e) => blurCheck(e, '1')}
          /><br/>
        </div>
        <div className={'form-group' + labelFocus['2']}>
          <label htmlFor="person2" className="control-label">Person 2</label>
          <input id="person2" type="text" className="form-control"
                 onChange={(e) => personChange(e)}
                 onFocus={() => {labelFocus['2'] = ' focused'; setLabelFocus({...labelFocus})}}
                 onBlur={(e) => blurCheck(e, '2')}
          /><br/>
        </div>
        <div className={'form-group' + labelFocus['3']}>
          <label htmlFor="person3" className="control-label">Person 3</label>
          <input id="person3" type="text" className="form-control"
                 onChange={(e) => personChange(e)}
                 onFocus={() => {labelFocus['3'] = ' focused'; setLabelFocus({...labelFocus})}}
                 onBlur={(e) => blurCheck(e, '3')}
          /><br/>
        </div>
        <div className={'form-group' + labelFocus['4']}>
          <label htmlFor="person4" className="control-label">Person 4</label>
          <input id="person4" type="text" className="form-control"
                 onChange={(e) => personChange(e)}
                 onFocus={() => {labelFocus['4'] = ' focused'; setLabelFocus({...labelFocus})}}
                 onBlur={(e) => blurCheck(e, '4')}
          /><br/>
        </div>
        <div className={'form-group' + labelFocus['5']}>
          <label htmlFor="person5" className="control-label">Person 5</label>
          <input id="person5" type="text" className="form-control"
                 onChange={(e) => personChange(e)}
                 onFocus={() => {labelFocus['5'] = ' focused'; setLabelFocus({...labelFocus})}}
                 onBlur={(e) => blurCheck(e, '5')}
          /><br/>
        </div>
        <div className={'form-group' + labelFocus['6']}>
          <label htmlFor="person6" className="control-label">Person 6</label>
          <input id="person6" type="text" className="form-control"
                 onChange={(e) => personChange(e)}
                 onFocus={() => {labelFocus['6'] = ' focused'; setLabelFocus({...labelFocus})}}
                 onBlur={(e) => blurCheck(e, '6')}
          /><br/>
        </div>
        <div className={'form-group' + labelFocus['7']}>
          <label htmlFor="person7" className="control-label">Person 7</label>
          <input id="person7" type="text" className="form-control"
                 onChange={(e) => personChange(e)}
                 onFocus={() => {labelFocus['7'] = ' focused'; setLabelFocus({...labelFocus})}}
                 onBlur={(e) => blurCheck(e, '7')}
          /><br/>
        </div>
        <div className={'form-group' + labelFocus['8']}>
          <label htmlFor="person8" className="control-label">Person 8</label>
          <input id="person8" type="text" className="form-control"
                 onChange={(e) => personChange(e)}
                 onFocus={() => {labelFocus['8'] = ' focused'; setLabelFocus({...labelFocus})}}
                 onBlur={(e) => blurCheck(e, '8')}
          /><br/>
        </div>
      </form>

      <div className="stepNav">
        <Link className="btn btn-secondary" to="/step0">Zurück</Link>
        <Link className="btn btn-primary" to="/step2a">Weiter</Link>
      </div>
    </div>
  );
}

export default Step1
;